import { ReactNode } from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./select";

interface SimpleSelectProps {
  onValueChange?: (value: string) => void;
  value?: string;
  disabled?: boolean;
  triggerClassName?: string;
  placeholder?: string;
  options: { value: string; label: ReactNode }[];
}
export function SimpleSelect({onValueChange, value, disabled, triggerClassName, placeholder, options}: SimpleSelectProps) {
  return (
    <Select onValueChange={onValueChange} value={value} disabled={disabled}>
      <SelectTrigger className={triggerClassName}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>

      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

